// extracted by mini-css-extract-plugin
export default {"container":"style_container__oNwi1","button":"style_button__dv3b5","buttonToCart":"style_buttonToCart__djLq3","title":"style_title__JynEg"};